import React, { useState, useRef, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { partnerHostStaging, partnerHostLive } from '../../../../../constants'

const Host = window.location.hostname

const QAPhotoPreviewScreen = ({ history }) => {
  const { token, bookingId } = useParams()

  const handleSubmit = () => {
    history.push(
      `${
        Host === partnerHostLive || Host === partnerHostStaging
          ? '/'
          : '/partner/'
      }driver/app/details/qaCheck/photoCapture/${token}/${bookingId}`
    )
  }

  const CheckPoint = ({ text }) => {
    return (
      <div
        className='important-info-qa'
        style={{ fontSize: '16px', paddingTop: 0 }}
      >
        <div>{text}</div>
      </div>
    )
  }

  return (
    <div className='qa-instructions-container'>
      <div>
        <img
          className='driver-back-icon-qa mx-50%'
          src='/images/icon-back.png'
          onClick={e => {
            e.preventDefault()
            window.history.back()
          }}
          alt='Back'
        />
      </div>

      <div className='scroll-view'>
        <div className='qa-content-block'>
          <h2 className='qa-heading'>Please make sure</h2>

          <div className='qa-preview-section'>
            <img
              src='/images/icons/chauffeur-preview.png'
              alt='Chauffeur'
              className='photo-chauffeur'
            />
            <CheckPoint text='You look neat, professional, and your face is clearly visible.' />
            <CheckPoint text='Your suit and tie are visible in the photo.' />
          </div>

          <div className='qa-preview-section'>
            <img
              src='/images/icons/vehicle-preview.png'
              alt='Vehicle'
              className='photo-vehicle'
            />
            <CheckPoint text='The photo is taken in landscape mode.' />
            <CheckPoint text='All amenities are clearly visible in the photo.' />
            <CheckPoint text='The interior of the vehicle is visible and appears clean and well-maintained.' />
          </div>
        </div>
      </div>

      <div className='driver-booking-cta-footer'>
        <Button
          className='select-btn select-vehicle mb-2'
          style={{
            width: '100%',
            fontWeight: '900',
            fontSize: '16px',
            textShadow: '0.25px 0 #ffffff',
          }}
          variant='brown'
          onClick={handleSubmit}
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default QAPhotoPreviewScreen
